import { render, staticRenderFns } from "./MyPagePointHistory.vue?vue&type=template&id=6f8569a6&scoped=true&"
import script from "./MyPagePointHistory.vue?vue&type=script&lang=js&"
export * from "./MyPagePointHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8569a6",
  null
  
)

export default component.exports